// removed by extract-text-webpack-plugin
module.exports = {"container":"MobileFeedbackCell__container___1NB3F","icon-grid":"MobileFeedbackCell__icon-grid___2K1AG","toggle-grid":"MobileFeedbackCell__toggle-grid___2ohQ1"};